<!--
 * @Description: 分页组件
 * @Autor: Zhongyu
 * @Date: 2021-05-07 18:45:30
 * @LastEditors: Zhongyu
 * @LastEditTime: 2022-02-08 17:34:54
-->
<template>
  <div v-show="total > 0" class="pagination">
    <!-- 下拉当页条数切换 start -->
    <div class="page-sizes">
      <span class="ptitle">
        共
      </span>
      <a-select
        v-model="pageSize"
        dropdown-class-name="default-select-dropdown"
        :get-popup-container="triggerNode => triggerNode.parentNode"
        @change="handleSelectChange"
      >
        <a-icon slot="suffixIcon" type="caret-down" theme="filled" />
        <a-select-option
          v-for="item in pageSizeOptions"
          :key="item"
          :value="item"
        >
          <span class="title">
            {{ item }}
          </span>
        </a-select-option>
      </a-select>
      <span class="ptitle">
        项结果
      </span>
    </div>
    <!-- 下拉当页条数切换 end -->

    <!-- 分页按钮 start -->
    <div class="page">
      <a-pagination
        v-model="page"
        :total="total || 1"
        :page-size="pageSize"
        :item-render="itemRender"
        @change="handlePaginationChange"
      />
      <!-- <div class="jump">
        <span class="text">到第</span>
        <a-input v-model="putPage" />
        <span class="text">页</span>
        <a-button @click="handlePaginationClick">确定</a-button>
      </div> -->
    </div>
    <!-- 分页按钮 end -->
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    // 总条数
    total: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pageSizeOptions: [10, 20, 30, 40, 50], // 每页条数组
      page: 1, // 页码
      pageSize: 10, // 每页条数
      putPage: ""
    };
  },
  methods: {
    /**
     * 提供父层调用更新页码和每页条数
     * @page 页码
     * @pageSize 每页条数
     */
    setData(page, pageSize) {
      if (page) {
        this.page = page;
      }
      // 筛选传入和每页条数是否在每页条数组中
      let pageSizeOption = this.pageSizeOptions.find(item => {
        return item == pageSize;
      });
      // 当存在赋值于每页条数上
      if (pageSizeOption) {
        this.pageSize = pageSize;
      }
    },

    /**
     * 把下一页和上一页转换成中文
     */
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return "<";
      } else if (type === "next") {
        return ">";
      } else if (type === "page") {
        return current;
      }
      return originalElement;
    },

    handlePaginationClick() {
      let putPage = this.putPage;
      let page = this.putPage;
      let totalPage = parseInt(this.total / this.pageSize);
      if (this.total % this.pageSize != 0) {
        totalPage += 1;
      }
      if (totalPage < page && totalPage > 0) {
        page = totalPage;
      }
      if (putPage > page) {
        this.putPage = Number(page);
      }
      this.page = Number(page);

      /**
       * 触发父层方法
       */
      this.$emit("change", this.putPage, this.pageSize);
    },

    /**
     * 页码改变的回调，参数是改变后的页码及每页条数
     * @page 页码
     * @pageSize 每页条数
     */
    handlePaginationChange(page, pageSize) {
      /**
       * 触发父层方法
       */
      this.$emit("change", page, pageSize);
    },

    /**
     * pageSize 变化的回调
     * @pageSize 每页条数
     */
    handleSelectChange(pageSize) {
      let page = this.page;
      let totalPage = parseInt(this.total / pageSize);
      if (this.total % pageSize != 0) {
        totalPage += 1;
      }
      if (totalPage < page && totalPage > 0) {
        page = totalPage;
      }
      this.page = page;
      /**
       * 触发父层方法
       */
      this.$emit("change", page, pageSize);
    }
  }
};
</script>

<style lang="less">
@import "./index.less";
</style>
